/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".auth-box[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{text-transform:uppercase;color:#aaa;font-size:15px;font-weight:700;letter-spacing:.2em}.auth-box[_ngcontent-%COMP%]   p.where-is-my-clientnumber[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#aaa;font-size:13px}.auth-box[_ngcontent-%COMP%]   p.where-is-my-clientnumber[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{margin-right:2px}.auth-box[_ngcontent-%COMP%]   p.alreadyhaveanaccount[_ngcontent-%COMP%]{padding-top:25px;color:#aaa;font-size:14px}"];
export { styles as styles };
